import { generateTheme } from '@talpanetwork/digital-sound-theme';

import palettes from './palettes';
import breakpoints from './breakpoints';
import zIndexes from './zIndexes';

const theme = (palette = 'default') =>
  generateTheme({
    palette: palettes[palette] || palettes.default,
    breakpoints,
    zIndex: zIndexes,
  });

export default theme;
